/**
 * 支付服务
 */
define(['dataServices', 'collectApi'], function (dataServices, collectApi) {
  /**
   * 检测模板是否已购买
   * @param {string} wpsSid
   * @param {int} tid
   * @return {Promise<bool>}
   */
  let isBought = function (wpsSid, tid) {
    let dfd = $.Deferred();
    if (wpsSid) {
      dataServices.get('easy/v3').isBought({ data: {
        wps_sid: wpsSid,
        mb_id: tid
      }}).done(function (result) {
        if (result.result === 'ok') {
          let isBuy = result.data.is_buy === 1;
          dfd.resolve(isBuy);
        } else {
          dfd.reject();
        }
      }).fail(dfd.reject);
    } else {
      dfd.resolve(false);
    }
    return dfd.promise();
  };

  /**
   * 获取支付二维码
   * @param {string} wpsSid
   * @param {int} tid
   * @param {string} payWay 支付方式
   * @param {string} channel 支付渠道，标记销售的来源，稻壳订单表记录
   * @param {string} subChannel 支付子渠道，标记销售的来源的进一步详细位置，稻壳订单表记录
   * @param {string} payOrigin 付来源，销售表记录
   * @return {Promise<object>}
   */
  let getPayQrCode = function (wpsSid, tid, payWay, channel, subChannel, payOrigin) {
    return _pay(wpsSid, tid, payWay, channel, subChannel, payOrigin);
  };

  /**
   * 使用稻米支付
   * @param {string} wpsSid
   * @param {int} tid
   * @param {string} channel 支付渠道，标记销售的来源，稻壳订单表记录
   * @param {string} subChannel 支付子渠道，标记销售的来源的进一步详细位置，稻壳订单表记录
   * @param {string} payOrigin 付来源，销售表记录
   * @return {Promise<object>}
   */
  let payByRice = function (wpsSid, tid, channel, subChannel, payOrigin) {
    return _pay(wpsSid, tid, 'daomi', channel, subChannel, payOrigin);
  };

  let _pay = function (wpsSid, tid, payWay, channel, subChannel, payOrigin) {
    let dfd = $.Deferred();
    dataServices.get('easy/v3').payForTemplate({ data: {
      wps_sid: wpsSid,
      pay_info: {
        mb_id: tid,
        pay_way: payWay,
        channel: channel,
        sub_channel: subChannel,
        pay_origin: payOrigin,
        // remote_ip, // 非必选项, 不传
        guig: collectApi.getGUID(),
        hdid: collectApi.getHDID(),
        uuid: collectApi.getUUID()
      }
    }}).done((result) => {
      if (result.result === 'ok') {
        dfd.resolve(result.data);
      } else {
        dfd.reject(result.msg);
      }
    }).fail(dfd.reject);
    return dfd.promise();
  };

  /**
   * 获取支付宝链接
   * @param {string} wpsSid
   * @param {int} orderId
   * @param {string} payOrigi
   * @return {Promise<string>}
   */
  let fetchAlipayUrl = function (wpsSid, orderId, payOrigin) {
    let dfd = $.Deferred();
    dataServices.get('easy/v3').fetchAlipayUrl({ data: {
      wps_sid: wpsSid,
      order_id: orderId,
      pay_origin: payOrigin
    }}).done((result) => {
      if (result.result === 'ok') {
        dfd.resolve(result.data.alipay_url);
      } else {
        dfd.reject(result.msg);
      }
    }).fail(dfd.reject);
    return dfd.promise();
  };

  /**
   * 检测订单是否已支付
   * @param {string} wpsSid
   * @param {int} orderId
   * @return {Promise<bool>}
   */
  let isOrderPaid = function (wpsSid, orderId) {
    const PAID = 1;
    let dfd = $.Deferred();
    dataServices.get('easy/v3').checkPayStatus({ data: {
      wps_sid: wpsSid,
      order_id: orderId
    }}).done((result) => {
      if (result.result === 'ok') {
        let isPaid = result.data.pay_status === PAID;
        dfd.resolve(isPaid);
      } else {
        dfd.reject();
      }
    }).fail(dfd.reject);
    return dfd.promise();
  };

  /**
   * 提交支付信息到服务端
   * @param {string} wpsSid
   * @param {int} templateId 模板ID
   */
  let recordPayment = function (wpsSid, templateId) {
    dataServices.get('easy/v3').payRecord({ data: {
      wps_sid: wpsSid,
      tid: templateId
    }});
  };

  return {
    isBought,
    getPayQrCode,
    payByRice,
    fetchAlipayUrl,
    isOrderPaid,
    recordPayment
  };
});



/** WEBPACK FOOTER **
 ** ./src/modules/unipay/scripts/service/payService.js
 **/